<template>
  <div>
    <div v-if="!isFreeTextAction">
      <div
        v-for="action in actions"
        :key="action.name"
        class="card bg-transparent my-3"
      >
        <ActionListExpandable
          :id="id"
          :action="action"
          :didClickExpandAction="didClickExpandAction"
          :isExpandedAction="isExpandedAction(action.actionName)"
          :numberOfUsersSelectedActions="numberOfUsersSelectedActions"
          :numberOfUsersThatHaveResponded="numberOfUsersThatHaveResponded"
          :selectedCategory="selectedCategory"
        >
          <ProposalActions
            :action="action"
            :categories="categories"
            :numberOfUsersThatHaveResponded="numberOfUsersThatHaveResponded"
          />
        </ActionListExpandable>
      </div>
    </div>
    <div v-else>
      <ActionListExpandable
        :id="id"
        :action="{
          actionName: 'other_actions',
          title: $t('widgetGroupActions.otherActions')
        }"
        :didClickExpandAction="didClickExpandAction"
        :isExpandedAction="isExpandedAction('other_actions')"
        :numberOfUsersSelectedActions="numberOfUsersSelectedActions"
        :numberOfUsersThatHaveResponded="numberOfUsersThatHaveResponded"
        :isFreeTextAction="isFreeTextAction"
      >
        <FreetextActions
          :actions="actions"
          :categories="categories"
          :selectedCategory="selectedCategory"
        />
      </ActionListExpandable>
    </div>
  </div>
</template>

<script>
import FreetextActions from './FreetextActions.vue'
import ProposalActions from './ProposalActions.vue'
import ActionListExpandable from './ActionListExpandable.vue'

export default {
  name: 'ActionsList',
  components: {
    FreetextActions,
    ActionListExpandable,
    ProposalActions
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Object,
      default: () => {}
    },
    numberOfUsersThatHaveResponded: {
      type: Number,
      default: 0
    },
    selectedCategory: {
      type: String,
      default: ''
    },
    isFreeTextAction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shouldExpandAll: false,
      expandedActions: {}
    }
  },
  computed: {
    numberOfUsersSelectedActions() {
      return this.actions.reduce((sum, action) => {
        sum = sum + action.numberOfPeople
        return sum
      }, 0)
    }
  },
  methods: {
    didClickExpandAction(actionName) {
      if (this.expandedActions[actionName]) {
        this.expandedActions = { ...this.expandedActions, [actionName]: false }
      } else {
        this.expandedActions = { ...this.expandedActions, [actionName]: true }
      }
    },
    isExpandedAction(actionName) {
      return this.expandedActions[actionName]
    }
  }
}
</script>
